module.exports = __webpack_public_path__ + "files/dzs1.pdf";